import Marquee from "react-fast-marquee";

const bigLines = [
  "No gurus",
  "No hacks",
  "Just humans in progress",
  "Sobriety is a power move",
  "Frogs can't become enlightened",
];

export const MarqueeTicker = () => {
  return (
    <div className="border-y border-[#232332] select-none" data-testid="marquee-ticker">
      <Marquee speed={50} gradient={false} autoFill className="py-4 sm:py-6 overflow-hidden">
        {bigLines.map((line, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-3xl sm:text-6xl md:text-7xl text-stroke whitespace-nowrap">
              {line}
            </span>
            <span className="font-display text-3xl sm:text-5xl text-[#C8FF3E] mx-6 sm:mx-8">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
